import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'services/api/api';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const createActivity = async body => {
	const response = await api.post('/atividade', body);
	return response.data;
};
export const useCreateActivity = (body, onClose) => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation(() => createActivity(body), {
		onSuccess: sucess => {
			queryClient.invalidateQueries(['activities-list']);
			onClose();

			toast({
				title: 'Criada com sucesso!',
				description: 'Atividade criada com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao cadastrar Família!'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
